/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown>, count: NonNullable<unknown> }} Ui_Sensor_Warning_Power_Above_MaxInputs */

const en_ui_sensor_warning_power_above_max = /** @type {(inputs: Ui_Sensor_Warning_Power_Above_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Power above ${i?.limit} W in ${i?.count} records — likely sensor error`)
};

const de_ui_sensor_warning_power_above_max = /** @type {(inputs: Ui_Sensor_Warning_Power_Above_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leistung über ${i?.limit} W in ${i?.count} Messpunkten – wahrscheinlich Sensorfehler`)
};

/**
* | output |
* | --- |
* | "Power above {limit} W in {count} records — likely sensor error" |
*
* @param {Ui_Sensor_Warning_Power_Above_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sensor_warning_power_above_max = /** @type {((inputs: Ui_Sensor_Warning_Power_Above_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sensor_Warning_Power_Above_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sensor_warning_power_above_max(inputs)
	return de_ui_sensor_warning_power_above_max(inputs)
});